import React from 'react';
import { useIntl } from 'react-intl';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import { InfoTooltipIcon } from '../Icon/SemanticIcons.esm.js';
import { Tooltip } from '../Tooltip/Tooltip.esm.js';

/*
 * Handles rendering of form controls and their related properties like labels and errors.
 */
function Field(_a) {
    var description = _a.description, label = _a.label, labelId = _a.labelId, _b = _a.optional, optional = _b === void 0 ? false : _b, error = _a.error, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, disabled = _a.disabled, control = _a.control, tooltip = _a.tooltip, _c = _a.showLabel, showLabel = _c === void 0 ? true : _c, _d = _a.connectLabel, connectLabel = _d === void 0 ? true : _d;
    var intl = useIntl();
    var labelTextClasses = classNames("tw-space-x-1 tw-mb-1", !showLabel && "tw-sr-only");
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId ||
            (label
                ? "field-".concat(typeof label === "string" && testIdGen(label))
                : "field"), className: "tw-font-lato tw-text-xs" },
        React.createElement("label", { className: "tw-block", id: labelId },
            React.createElement("div", { className: labelTextClasses },
                React.createElement("span", null, label),
                optional && (React.createElement("span", { className: "tw-text-secondary" }, intl.formatMessage({ id: "6Pi4kz", defaultMessage: [{ type: 0, value: "(Optional)" }] }))),
                tooltip && (React.createElement(Tooltip, { label: tooltip },
                    React.createElement(InfoTooltipIcon, { "aria-label": tooltip })))),
            connectLabel && control),
        !connectLabel && control,
        error && React.createElement("div", { className: "tw-text-red" }, error),
        description && (React.createElement("div", { className: classNames("tw-mt-1", disabled
                ? "tw-text-disabled dark:tw-text-dark-bg-disabled"
                : "tw-text-secondary dark:tw-text-dark-bg-secondary") }, description))));
}

export { Field };
//# sourceMappingURL=Field.esm.js.map
